import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { observer } from 'mobx-react';
import { ROUTE_LOGIN } from 'RouteList';
import { useStores } from '../store/useStores';

function PrivateRoute() {
  const { authStore } = useStores();
  const { isLoggedIn } = authStore;

  if (!isLoggedIn) {
    return <Navigate to={ROUTE_LOGIN} replace />;
  }

  return <Outlet />;
}

export default observer(PrivateRoute);
